import type { SignLanguageId } from "./signLanguages";

export interface Unit {
  id: string;
  language: SignLanguageId;
  title: string;
  subtitle: string;
  kind: "letters" | "words";
  /** Letter ids (kind "letters") or words written in the language's script (kind "words"). */
  items: string[];
  lessons: number;
  comingSoon?: boolean;
}

export const LESSON_LENGTH = 5;

export const UNITS: Unit[] = [
  // Pakistan Sign Language — Urdu fingerspelling (still handshapes only; moving letters come later).
  {
    id: "psl-alphabet-1",
    language: "psl",
    title: "Urdu letters ا – ذ",
    subtitle: "12 letters",
    kind: "letters",
    items: ["alif", "bay", "pay", "tay", "ttay", "say", "chay", "hay-hutti", "khay", "dal", "ddal", "zaal"],
    lessons: 3,
  },
  {
    id: "psl-alphabet-2",
    language: "psl",
    title: "Urdu letters ر – ف",
    subtitle: "12 letters",
    kind: "letters",
    items: ["ray", "zay", "zhay", "seen", "sheen", "suad", "zuad", "toay", "zoay", "ain", "ghain", "fay"],
    lessons: 3,
  },
  {
    id: "psl-alphabet-3",
    language: "psl",
    title: "Urdu letters ق – ے",
    subtitle: "12 letters",
    kind: "letters",
    items: ["qaf", "kaf", "gaf", "lam", "meem", "noon", "noon-ghunna", "wao", "do-chashmi-hay", "hamza", "choti-yay", "bari-yay"],
    lessons: 3,
  },
  {
    id: "psl-words",
    language: "psl",
    title: "Fingerspell Urdu words",
    subtitle: "سلام، نام، دوست…",
    kind: "words",
    items: ["سلام", "نام", "دوست", "کتاب", "پانی", "امی", "ابو", "دل"],
    lessons: 3,
  },
  {
    id: "psl-phrases",
    language: "psl",
    title: "Everyday phrases",
    subtitle: "Coming soon",
    kind: "words",
    items: [],
    lessons: 5,
    comingSoon: true,
  },
  {
    id: "psl-moving",
    language: "psl",
    title: "Moving letters آ ج ڑ ہ",
    subtitle: "Coming soon",
    kind: "letters",
    items: [],
    lessons: 3,
    comingSoon: true,
  },

  // American Sign Language
  { id: "alphabet-1", language: "asl", title: "Alphabet A–I", subtitle: "9 letters", kind: "letters", items: "abcdefghi".split(""), lessons: 3 },
  { id: "alphabet-2", language: "asl", title: "Alphabet J–R", subtitle: "9 letters", kind: "letters", items: "jklmnopqr".split(""), lessons: 3 },
  { id: "alphabet-3", language: "asl", title: "Alphabet S–Z", subtitle: "8 letters", kind: "letters", items: "stuvwxyz".split(""), lessons: 3 },
  {
    id: "words",
    language: "asl",
    title: "Fingerspell words",
    subtitle: "Short everyday words",
    kind: "words",
    items: ["cat", "dog", "sun", "hat", "map", "bed", "cup", "fox", "jam", "kid"],
    lessons: 3,
  },
  { id: "months", language: "asl", title: "Months of the year", subtitle: "Coming soon", kind: "words", items: [], lessons: 5, comingSoon: true },
  { id: "days", language: "asl", title: "Days of the week", subtitle: "Coming soon", kind: "letters", items: [], lessons: 5, comingSoon: true },
];

export const findUnit = (id: string | undefined) => UNITS.find((u) => u.id === id);

export const unitsFor = (language: SignLanguageId) => UNITS.filter((u) => u.language === language);
